import React from 'react';
import { Divider } from 'antd';
import { toRupiah, getLastSubId } from '../../utils/commonUtils';
import { PrintDateMonthYear } from '../../utils/timeParser';
import Wrapper from './style';
import PROMOTER from '../../configs/promoter';

const { DISCOUNT_TYPE } = PROMOTER;

const Index = (props) => {
  const { data: ad, localData: adLocal } = props;
  const adSet = ad?.ad_set;
  const campaign = adSet?.campaign;
  const adSetLocal = adLocal?.ad_set_local || {};
  const campaignLocal = adSetLocal?.campaign_local || {};

  const dateRange = (startDate, endDate) => {
    if (!startDate || !endDate) return '-';
    return `${PrintDateMonthYear(startDate)} - ${PrintDateMonthYear(endDate)}`;
  };

  const promotionDiscountValue = () => {
    const discountType = ad?.discount_type;
    if (discountType) {
      if (discountType === DISCOUNT_TYPE.PERCENTAGE.value) {
        return ad.discount ? `${ad.discount}%` : '-';
      }
      return toRupiah(ad.discount);
    }
    return `Promotion Code: ${ad?.promo_code}`;
  };

  return (
    <Wrapper>
      <div className="font-subtitle2_medium black1">Campaign Info</div>
      <div className="component_detailAd_grid">
        <div>
          <div className="field">Campaign Name</div>
          <div>{campaignLocal?.name || campaign?.name}</div>
        </div>
        <div>
          <div className="field">Campaign ID</div>
          <div>{getLastSubId(campaign?.id)}</div>
        </div>
        <div>
          <div className="field">Campaign Budget</div>
          <div className="budget">{toRupiah(campaign?.budget)}</div>
        </div>
        <div>
          <div className="field">Campaign Schedule</div>
          <div>{dateRange(campaign?.start_date, campaign?.end_date)}</div>
        </div>
      </div>
      <Divider />

      <div className="font-subtitle2_medium black1">Ad Set Info</div>
      <div className="component_detailAd_grid">
        <div>
          <div className="field">Ad Set Name</div>
          <div>{adSetLocal?.name || adSet?.name}</div>
        </div>
        <div>
          <div className="field">Ad Set ID</div>
          <div>{getLastSubId(adSet?.id)}</div>
        </div>
        <div>
          <div className="field">Ad Set Budget</div>
          <div className="budget">{toRupiah(adSet?.budget)}</div>
        </div>
        <div>
          <div className="field">Ad Set Schedule</div>
          <div>{dateRange(adSet?.start_date, adSet?.end_date)}</div>
        </div>
      </div>
      <Divider />

      <div className="font-subtitle2_medium black1">Ad Info</div>
      <div className="component_detailAd_grid">
        <div>
          <div className="field">Ad Name</div>
          <div>{adLocal?.name || ad?.name}</div>
        </div>
        <div>
          <div className="field">Ad ID</div>
          <div>{getLastSubId(ad?.id)}</div>
        </div>
        <div>
          <div className="field">Ad Budget</div>
          <div className="budget">{toRupiah(ad?.budget)}</div>
        </div>
        <div>
          <div className="field">Ad Schedule</div>
          <div>{dateRange(ad?.start_date, ad?.end_date)}</div>
        </div>
        <div>
          <div className="field">Ad Headline</div>
          <div>{ad?.headline}</div>
        </div>
      </div>
      <Divider />

      <div className="font-subtitle2_medium black1">Ad Promo</div>
      <div className="component_detailAd_grid">
        <div>
          <div className="field">Product Name</div>
          <div>{ad?.product_name ?? '-'}</div>
        </div>
        <div>
          <div className="field">SKU ID</div>
          <div>{ad?.sku ?? '-'}</div>
        </div>
        <div>
          <div className="field">UPC ID</div>
          <div>{ad?.upc_user ?? '-'}</div>
        </div>
        <div>
          <div className="field">Promo Discount/offer</div>
          <div>{promotionDiscountValue() ?? '-'}</div>
        </div>
        <div>
          <div className="field">Promo Code</div>
          <div>{ad?.promo_code ?? '-'}</div>
        </div>
      </div>
      <Divider />

      <div className="font-subtitle2_medium black1">Ad Content</div>

      <div className="component_detailAd_grid">
        <div className="fullWidth">
          <div className="field">Content</div>
          <div>{ad?.content ?? '-'}</div>
        </div>
        <div>
          {/* <div className="field">Url</div>
          <Link to="https://www.brandname.id/safe=active&rlz=1">
            <div className="url">https://dummy.url</div>
          </Link> */}
        </div>
        <div>
          {/* <div className="field">Tags</div>
          <div className="font-paragraph_medium">Dummy, tag</div> */}
        </div>
      </div>
      <Divider />
    </Wrapper>
  );
};

export default Index;
